import { Search } from "lucide-react"
import { OpportunitySearch } from "./OpportunitySearch"

interface OpportunityHeaderProps {
  onFiltersChange: (filters: {
    focus_areas?: string[]
    beneficiary_types?: string[]
    opportunity_type?: string
    subtype?: string
    sdg_alignment?: string[]
    format?: string
    duration?: string
    employee_resource_group?: string
    location?: string
  }) => void
}

export const OpportunityHeader = ({ onFiltersChange }: OpportunityHeaderProps) => {
  return (
    <div className="bg-white border-b shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <h1 className="text-xl font-semibold text-gray-900">
            Volunteer Opportunities
          </h1>
          <div className="w-[500px]">
            <OpportunitySearch onFiltersChange={onFiltersChange} />
          </div>
        </div>
      </div>
    </div>
  )
}